import { MediaContentDTO } from "@touche-lts/panel-ui/dist";

export interface Department {
    squareCrop: MediaContentDTO
    backgroundCrop: MediaContentDTO
    id: number
    name: string;
    categories: Partial<DepartmentCategory[]>
    categoryCount: number;
    subcategoryCount: number;
    typeCount: number;
    subtypeCount: number;
}

export interface DepartmentCategory {
    id?: number;
    name: string;
    subcategories: DepartmentSubcategory[],
    types: DepartmentType[]
    backgroundCrop?: Partial<MediaContentDTO>;
    squareCrop?: Partial<MediaContentDTO>;
}

export interface DepartmentSubcategory {
    id?: number;
    name: string;
}

export interface DepartmentType {
    id?: number;
    name: string
    parentSubcategory?: ParentSubcategory
    subtypes: DepartmentSubcategory[];
}

export interface DepartmentTypes {
    id: number;
    name: string;
    parentSubcategory: ParentSubcategory
    subtypes: DepartmentSubcategory[];
}

export interface DepartmentFilterPayload {
    categories: {id: number}[];
    subcategories: {id: number}[];
    types: {id: number}[];
    stores: {id: number}[];
}

export interface DepartmentCategoryFilters {
    categories: any[];
    stores: any[];
    manufacturers: any[];
    subcategories: any;
    types: any[];
    priceMin: number;
    priceMax: number;
    ratingMin?: number;
    ratingMax?: number;
    selectedPriceMin?: number;
    selectedPriceMax?: number;
}

export enum CategoriesSortBy {
    BESTSELLING = 'Best selling',
    TOPRATED = 'Top rated'
}

export enum filterRatingCategories {
    UP = '& Up',
    DOWN = '& Down'
}

export interface ParentSubcategory {id?: number, name: string}